/**
 * @desc 手动上架库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.shelvesStock.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/shelvesStock`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
